// Инициализация при загрузке страницы
document.addEventListener('DOMContentLoaded', function() {
    // Инициализация AOS
    AOS.init({
        once: true,
        offset: 100,
        duration: 800,
        easing: 'ease-in-out'
    });

    // Добавляем класс для анимации всем кнопкам
    ['langBtn', 'phoneBtn', 'emailBtn', 'whatsappBtn'].forEach(btnId => {
        const btn = document.getElementById(btnId);
        if (btn) btn.classList.add('contact-button');
    });

    // Показываем кнопки через 675мс
    setTimeout(showButtons, 675);

    // Initialize scroll arrow
    initScrollArrow();
});

// Функция переключения Impressum
function toggleImpressum() {
    const button = document.querySelector('button[onclick="toggleImpressum()"]');
    const lang = button?.getAttribute('data-lang') || 'de';
    const contentId = lang === 'en' ? 'fullImpressumEn' : 'fullImpressumDe';
    const content = document.getElementById(contentId);
    
    if (content) {
        if (content.style.display === 'none' || !content.style.display) {
            content.style.display = 'block';
            button.textContent = lang === 'en' ? 'Hide Details' : 'Details ausblenden';
        } else {
            content.style.display = 'none';
            button.textContent = lang === 'en' ? 'More Details' : 'Mehr Details';
        }
    }
}

// Функция переключения Datenschutz
function toggleDatenschutz() {
    const content = document.getElementById('fullDatenschutz');
    const button = document.querySelector('button[onclick="toggleDatenschutz()"]');
    
    if (content && button) {
        if (content.style.display === 'none' || !content.style.display) {
            content.style.display = 'block';
            button.textContent = 'Details ausblenden';
        } else {
            content.style.display = 'none';
            button.textContent = 'Mehr Details';
        }
    }
}

// Функция переключения Privacy Policy
function togglePrivacy() {
    const content = document.getElementById('fullPrivacy');
    const button = document.querySelector('button[onclick="togglePrivacy()"]');
    
    if (content && button) {
        if (content.style.display === 'none' || !content.style.display) {
            content.style.display = 'block';
            button.textContent = 'Hide Details';
        } else {
            content.style.display = 'none';
            button.textContent = 'More Details';
        }
    }
}

// Функция показа кнопок
function showButtons() {
    ['langBtn', 'phoneBtn', 'emailBtn', 'whatsappBtn'].forEach(btnId => {
        const btn = document.getElementById(btnId);
        if (btn) {
            btn.classList.remove('instant-hide');
            btn.style.opacity = '1';
        }
    });
}

// Обработка скролла
let timeout;
window.addEventListener('scroll', () => {
    clearTimeout(timeout);
    ['langBtn', 'phoneBtn', 'emailBtn', 'whatsappBtn'].forEach(btnId => {
        const btn = document.getElementById(btnId);
        if (btn) {
            btn.classList.add('instant-hide');
            btn.style.opacity = '0';
        }
    });
    timeout = setTimeout(showButtons, 675);
});

// Scroll Arrow Logic
let hasUserInteracted = false;
let arrowTimeout;

// Show arrow after 3 seconds if user hasn't interacted
function showArrow() {
    const scrollArrow = document.getElementById('scrollArrow');
    if (!hasUserInteracted && scrollArrow) {
        scrollArrow.style.opacity = '1';
    }
}

// Hide arrow on user interaction
function hideArrow() {
    const scrollArrow = document.getElementById('scrollArrow');
    if (!hasUserInteracted && scrollArrow) {
        scrollArrow.style.opacity = '0';
        hasUserInteracted = true;
        clearTimeout(arrowTimeout);
    }
}

// Initialize arrow behavior
function initScrollArrow() {
    const scrollArrow = document.getElementById('scrollArrow');
    if (!scrollArrow) return;

    // Show arrow after 3 seconds
    arrowTimeout = setTimeout(showArrow, 3000);

    // Event listeners for user interaction
    window.addEventListener('scroll', hideArrow);
    window.addEventListener('click', hideArrow);
    window.addEventListener('touchstart', hideArrow);

    // Click event on arrow
    scrollArrow.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
            top: window.innerHeight,
            behavior: 'smooth'
        });
        hideArrow();
    });
} 